import styled from "@emotion/styled";
import { Box } from "Application";

export const TableData = styled.div`
    .mainTable {
        & > div {
            &:first-child {
                background: #f3f3f3;
                & > div {
                    grid-template-columns: 9fr 9fr 9fr 4fr 3fr 1fr !important;
                }
            }
            & > div {
                grid-template-columns: 9fr 9fr 9fr 4fr 3fr 1fr !important;
                &:nth-of-type(even) {
                    background: #f9f9f9;
                }
                & > div {
                    width: 100%;
                    box-sizing: border-box;
                    &:last-child {
                        border-right: none;
                        > div {
                            justify-content: center;
                        }
                    }
                    &:nth-of-type(4) {
                        > div {
                            justify-content: center;
                        }
                    }
                }
            }
        }
        .justifyCenter {
            > div {
                justify-content: center;
            }
        }
        #lastAction {
            justify-content: flex-end;
        }
    }

    .yellowBtn {
        height: 30px;
        border-radius: 5px;
        letter-spacing: 0px;
        color: #000000;
        text-transform: uppercase;
        font-size: 12px;
        line-height: 17px;
        font-family: OpenSans-CondBold;
        background-color: #fcd21d;
        border: none;
        width: 100%;
        display: block;
        box-sizing: border-box;
        padding: 6px 30px !important;
        cursor: pointer;
        margin: 0 auto;
        @media only screen and (max-width: 600px) {
            width: 100% !important;
            min-width: 100% !important;
        }
    }
`;

export const ViewMentorDetailsButton = styled.button`
    height: 30px;
    border-radius: 5px;
    letter-spacing: 0px;
    color: #000000;
    text-transform: uppercase;
    font-size: 12px;
    line-height: 17px;
    font-family: OpenSans-CondBold;
    background-color: #fcd21d;
    border: none;
    width: 100%;
    display: block;
    box-sizing: border-box;
    padding: 6px 30px;
    cursor: pointer;
    @media only screen and (max-width: 1800px) {
        padding: 6px 20px;
    }
    @media only screen and (max-width: 1600px) {
        padding: 6px 10px;
    }
`;

export const AddMentor = styled.div`
    .add-mentor {
        min-width: 310px;
        height: 40px;
        @media only screen and (max-width: 1100px) {
            min-width: 250px;
            position: relative;
            z-index: 9;
            // border-radius: 0px;
        }
        @media only screen and (max-width: 767px) {
            padding: 8px 12px;
        }
    }
`;

export const PageHeaderBtn = styled(Box)`
    position: absolute;
    top: 30px;
    right: 0px;
    @media only screen and (max-width: 991px) {
        top: 85px;
    }
`;
